// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-item-content {
  position: relative !important;
}

.carousel-item-content > div {
  position: absolute !important;
  z-index: 2 !important;
  width: 100%;
  height: 100%;
  margin-top: -120px !important;
  padding-left: 81px;
}
.bannerDesc{
  padding: 0 5vw;
  margin-top: 0px;
}
.carousel-item-content > div > p:first-child {
  color: #FFF;
  font-family: Thicker;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 44.8px */
  padding: 0 !important;
  margin: 0 !important;
}
.secondHeadingCorporate{
  color: black;
    font-family: Thicker;
    font-size: clamp(18px, 5vw, 40px);
    font-style: normal;
    font-weight: 400;
    text-transform: uppercase;
    margin: -100px 0 30px 0;
    padding: 0 5vw;
}
.whyjoin{
  margin-top: 30px !important;
  padding: 0 5vw;
  color: black;
  font-family: Thicker;
  font-size: clamp(18px, 4vw, 30px);
  font-style: normal;
  font-weight: 400;
}
.unorderdListCorporate li{
  font-size: 18px;
}
.carousel-item-content > div > p:last-child {
  color: #FFF;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding: 0 !important;
  margin: 6px 0 0 0 !important;
}

.corporateContainer > p {
  width: 80%;
  margin: 20px auto;
  color: #000;
  font-family: lightThicker !important;
  font-size: clamp(16px, 4vw, 20px) !important;
}
.carousel-item {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.carousel-image {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
}

.carousel-text {
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: white; /* Example styling */
}

.corporateContainer {
  margin: 50px auto;
}
.corporateContainer > h1 {
  color: #000;
  font-size: clamp(30px, 4vw, 36px) !important;
  font-weight: 600;
  width: 80%;
  margin: auto;
}
.bottomCorporate {
  width: 100% !important; 
  padding: 50px 0px !important;
  background-color: #ba1e24;
  text-align: center;
  margin: 50px 0px;
}
.bottomCorporate > h1 {
  color: #fff;
  font-size: clamp(40px, 4vw, 54px) !important;
  font-weight: 700;
  margin-bottom: 20px;
}
.bottomCorporate > p {
  color: #fff !important;
  text-align: center;
  font-size: clamp(16px, 4vw, 20px) !important;
  margin-bottom: 0px !important;
  font-family: lightThicker !important;
}
.bottomCorporate > button {
  margin-top: 60px;
  color: #fff;
  font-size: clamp(18px, 4vw, 24px) !important;
  font-weight: 600;
  padding: 10px 20px;
  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;
  border: none;
  cursor: pointer;
}
.corporateContainer > div {
  display: flex;
  width: 100%;
  /* justify-content: center; */
  margin: auto auto 50px auto;
  padding: 0 80px;
  flex-wrap: wrap;
}
.corporateContainer > h1 {
  margin-top: 50px;
  width: 100%;
  padding: 0 80px;
}
.corporateContainer > div > div {
  background-color: #eaeaea;
  padding: 10px;
  margin: 10px;
}
.container1{
  background-color: white !important;
  color: #ba1e24 !important;

}


.corporateContainer > div > div > p {
  padding: 10px 0px;
  margin: 10px 0px;
}
.corporateContainer > div > div > div {
  display: flex;
  align-items: center;
  color: #000;
  font-size: clamp(16px, 4vw, 22px) !important;
  font-weight: 700;
}
.corporateContainer > div > div > div > span {
  color: #000;
  font-family: lightThicker !important;
  font-size: clamp(16px, 4vw, 22px) !important;
  font-weight: 400;
}
.slider > div > button {
  background-color: #000 !important;
}
.slider > div > button.slick-arrow.slick-prev {
  background-color: #000 !important;
  position: absolute !important;
  left: 0px !important;
  color: black !important;
  border: 1px solid black !important;
}
.slider > div > button.slick-arrow.slick-next {
  position: absolute !important;
  right: 0px !important;
  border: 1px solid black !important;
}

.slider > div,
.slider > div > div {
  width: 100% !important;
}
.slider > div > div > div > div > div > div > div {
  width: 100%;
  height: 60vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.slider > div > div > div > div > div > div > div > div {
  position: relative;
  top: 550px;
}
/* .cardSlider {
  height: 200px;
  width: 100%;
} */
/* .cardSlider > div > button {
  background-color: black !important;
}
.cardSlider > div > div > div > div {
  width: 400px !important;
  background: #fff;
  margin: 5px;
  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);
}
.cardSlider > div > div > div > div > div > div > div > p {
  color: #000;
  font-family: lightThicker !important;
  font-size: 14px;
  font-weight: 400;
}
.cardSlider > div > div > div > div > div > div > div > div > div > img {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  object-fit: cover;
}
.cardSlider > div > div > div > div > div > div > div > div > div > h3 {
  color: #000;
  font-size: 14px;
  font-weight: 600;
}
.cardSlider > div > div > div > div > div > div > div > div > div > p {
  color: #000;
  font-size: 12px;
  font-family: lightThicker !important;
} */
.cardSlider,
.cardSlider > div,
.cardSlider > div > div {
  width: 100% !important;
}
.description > p {
  color: #000 !important;
  font-family: lightThicker !important;
  font-size: 14px !important;
  font-weight: 100 !important;
}
.cardDiv {
  display: flex !important; 
}
.cardDiv > img {
  height: 40px !important;
  width: 40px !important;
  border-radius: 50% !important;
  object-fit: cover;
  margin-right: 10px !important;
}
.cardDiv > div > h2 {
  color: #000;
  font-size: 14px !important;
  margin: 0px !important;
}
.cardDiv > div > p {
  color: #000;
  font-weight: 100 !important;
  font-family: lightThicker !important;
  font-size: 12px !important;
  margin: 0px !important;
}
.cardWidth {
  width: 100% !important;
  background: #fff !important;
  border: none !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
}
.corporate_form_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.corporate_form_div {
  width: 100%;
  padding: 0 80px;
}

.corporate_form {
  width: 100%;
  display: flex;
  margin-top: 30px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20 !important;
}

.corporate_field_box {
  width: calc(33% - 20px);
  display: flex;
  flex-direction: column;
  margin: 0 10px 25px 10px;
}

.corporate_field_box > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
}

.corporate_field {
  height: 50px !important;
  flex-shrink: 0;
  padding: 0 17px;

  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
}

.corporate_text_area {
  width: 66%;
  display: flex;
  flex-direction: column;
  margin: 0 0 25px 0;
}

.corporate_text_area > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
}

.corporate_text_area_field {
  height: 152px !important;
  flex-shrink: 0;
  padding: 0 17px;

  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
  resize: none;
}

.corporate_invalid_feedback {
  color: #e42323;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
  margin-top: 4px;
}

.corporate_join_btn_div {
  display: flex;
  width: 180px;
  height: 54px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;
  color: #fff;
  font-family: lightThicker;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  border: none;
  margin-bottom: 50px;
}


@media screen and (max-width: 1200px) {

.corporateContainer > div {
  width: 100%;
  margin: auto 0 50px 0;
  padding: 0 80px;
  flex-wrap: wrap;
}

.corporateContainer > h1 {
  width: 100%;
  margin: auto;
  padding: 0 80px;
}


  .corporate_form_div {
    width: 100%;
    padding: 0 50px;
  }

  .corporate_form {
    /* justify-content: space-between; */
    gap: 20 !important;
  }

  .corporate_field_box {
    width: calc(33% - 20px);
    margin: 0 10px 20px 10px;
  }

  .corporate_field_box > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .corporate_field {
    height: 50px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .corporate_text_area {
    width: 66%;
    margin: 0 0 20px 0;
  }

  .corporate_text_area > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .corporate_text_area_field {
    height: 130px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .corporate_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .corporate_join_btn_div {
    width: 150px;
    height: 45px;
    gap: 10px;
    font-size: 20px;
    margin-bottom: 60px;
  }



}


@media screen and (max-width: 1200px) {
  .corporateContainer > div {
    /* width: 90%; */
  }

  .carousel-item-content > div {
    margin-top: -100px !important;
    padding-left: 60px;
  }

  .carousel-item-content > div > p:first-child {
    font-size: 28px;
  }
  
  .carousel-item-content > div > p:last-child {
    font-size: 18px;
    margin: 2px 0 0 0 !important;
  }

  .corporateContainer > div {
    width: 100%;
    margin: auto 0 50px 0;
    padding: 0 80px;
    flex-wrap: wrap;
  }
  
  .corporateContainer > h1 {
    width: 100%;
    margin: auto;
    padding: 0 80px;
  }
}

@media screen and (max-width: 1024px) {

.corporateContainer > div {
  padding: 0 60px;
}

.corporateContainer > h1 {
  padding: 0 60px;
}
.corporate_form_div {
  width: 100%;
  padding: 0 30px;
}

.corporate_form {
  /* justify-content: space-between; */
  gap: 20 !important;
}

.corporate_field_box {
  width: calc(50% - 6px);
  margin: 0 3px 16px 3px;
}

.corporate_field_box > label {
  font-size: 16px;
  margin-bottom: 2px;
}

.corporate_field {
  height: 45px !important;
  padding: 0 14px;
  font-size: 14px;
  line-height: 18px;
}

.corporate_text_area {
  width: 100%;
  margin: 0 0 16px 0;
}

.corporate_text_area > label {
  font-size: 16px;
  margin-bottom: 2px;
}

.corporate_text_area_field {
  height: 120px !important;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 18px;
}

.corporate_invalid_feedback {
  font-size: 14px;
  line-height: 18px;
  margin-top: 4px;
}

.corporate_join_btn_div {
  width: 140px;
  height: 42px;
  gap: 10px;
  font-size: 18px;
  margin-bottom: 60px;
}
}



@media screen and (max-width: 800px) {

  .carousel-item-content > div {
    margin-top: -80px !important;
    padding-left: 20px;
  }
.secondHeadingCorporate 
{
  margin: -50px 0 30px 0;
}
.unorderdListCorporate li{
  font-size: 16px;
}
  .carousel-item-content > div > p:first-child {
    font-size: 24px;
  }
  
  .carousel-item-content > div > p:last-child {
    font-size: 16px;
    line-height: 20px;
    margin: 0 !important;
  }

  .corporateContainer > div {
    padding: 0 30px;
  }
  
  .corporateContainer > h1 {
    padding: 0 30px;
  }
}


@media screen and (max-width: 600px) {
.bannerDesc{
  margin-top: 12px;
}
  .corporateContainer > div {
    width: 100% !important;
    padding: 0 16px;
  } 

  .corporateContainer > div > div {
    padding: 10px;
    margin: 10px 0;
    width: 100%;
  }

  .corporateContainer > h1 {
    margin-top: 20px;
    margin-left: 0 !important;
    padding: 0 20px;
    font-size: 26px !important;
    line-height: 26px;
  }
  .corporateContainer > p {
    width: 90%; 
    margin-bottom: 20px;
  }
  .slider > div,
  .slider > div > div {
    width: 100% !important;
  }
  .bottomCorporate > button {
    margin-top: 20px;
    padding: 4px 15px;
  }
  .bannerHeadingSubHeading p {
    display: none;
  }

  .corporate_form_div {
    width: 100%;
    padding: 0 20px;
  }
 
  .corporate_form {
    /* justify-content: space-between; */
    gap: 10 !important;
  }

  .corporate_field_box {
    width: 100%;
    margin: 0 0 16px 0;
  }

  .corporate_field_box > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .corporate_field {
    height: 45px !important;
    padding: 0 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .corporate_text_area {
    width: 100%;
    margin: 0 0 12px 0;
  }

  .corporate_text_area > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .corporate_text_area_field {
    height: 120px !important;
    padding: 10px 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .corporate_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .corporate_join_btn_div {
    width: 140px;
    height: 42px;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 60px;
  }

  .carousel-item-content > div {
    margin-top: -40px !important;
    padding-left: 10px;
  }

  .carousel-item-content > div > p:first-child {
    font-size: 18px;
  }
  
  .carousel-item-content > div > p:last-child {
    font-size: 12px;
    line-height: 16px;
    margin: 0 !important;
    display: none;
  }


  .corporateContainer > div >div > img {
    width: 100% !important;
  }
}





@media screen and (max-width: 450px) {

  .corporateContainer > h1 {
    margin-top: -20px !important;
    padding: 0 16px;
    font-size: 20px !important;
    line-height: 26px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/categories/corporate.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,YAAY;IACV,oBAAoB;IACpB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;AAClB;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,oCAAoC;EACpC,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,yBAAyB;;AAE3B;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;GAGG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;AACH;;;EAGE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,4DAA4D;AAC9D;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iEAAiE;EACjE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;;EAGE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;;;AAIF;;;AAGA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;;;;AAIA;;EAEE;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;EAEE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;AACA;EACE,gBAAgB;AAClB;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;EACf;;;EAGA;IACE,sBAAsB;EACxB;AACF;;;;;;AAMA;;EAEE;IACE,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;EACnB;;AAEF","sourcesContent":[".carousel-item-content {\n  position: relative !important;\n}\n\n.carousel-item-content > div {\n  position: absolute !important;\n  z-index: 2 !important;\n  width: 100%;\n  height: 100%;\n  margin-top: -120px !important;\n  padding-left: 81px;\n}\n.bannerDesc{\n  padding: 0 5vw;\n  margin-top: 0px;\n}\n.carousel-item-content > div > p:first-child {\n  color: #FFF;\n  font-family: Thicker;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 140%; /* 44.8px */\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.secondHeadingCorporate{\n  color: black;\n    font-family: Thicker;\n    font-size: clamp(18px, 5vw, 40px);\n    font-style: normal;\n    font-weight: 400;\n    text-transform: uppercase;\n    margin: -100px 0 30px 0;\n    padding: 0 5vw;\n}\n.whyjoin{\n  margin-top: 30px !important;\n  padding: 0 5vw;\n  color: black;\n  font-family: Thicker;\n  font-size: clamp(18px, 4vw, 30px);\n  font-style: normal;\n  font-weight: 400;\n}\n.unorderdListCorporate li{\n  font-size: 18px;\n}\n.carousel-item-content > div > p:last-child {\n  color: #FFF;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  padding: 0 !important;\n  margin: 6px 0 0 0 !important;\n}\n\n.corporateContainer > p {\n  width: 80%;\n  margin: 20px auto;\n  color: #000;\n  font-family: lightThicker !important;\n  font-size: clamp(16px, 4vw, 20px) !important;\n}\n.carousel-item {\n  position: relative;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n}\n\n.carousel-image {\n  width: 100%;\n  height: auto;\n  display: block;\n  position: relative;\n}\n\n.carousel-text {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  color: white; /* Example styling */\n}\n\n.corporateContainer {\n  margin: 50px auto;\n}\n.corporateContainer > h1 {\n  color: #000;\n  font-size: clamp(30px, 4vw, 36px) !important;\n  font-weight: 600;\n  width: 80%;\n  margin: auto;\n}\n.bottomCorporate {\n  width: 100% !important; \n  padding: 50px 0px !important;\n  background-color: #ba1e24;\n  text-align: center;\n  margin: 50px 0px;\n}\n.bottomCorporate > h1 {\n  color: #fff;\n  font-size: clamp(40px, 4vw, 54px) !important;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.bottomCorporate > p {\n  color: #fff !important;\n  text-align: center;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  margin-bottom: 0px !important;\n  font-family: lightThicker !important;\n}\n.bottomCorporate > button {\n  margin-top: 60px;\n  color: #fff;\n  font-size: clamp(18px, 4vw, 24px) !important;\n  font-weight: 600;\n  padding: 10px 20px;\n  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;\n  border: none;\n  cursor: pointer;\n}\n.corporateContainer > div {\n  display: flex;\n  width: 100%;\n  /* justify-content: center; */\n  margin: auto auto 50px auto;\n  padding: 0 80px;\n  flex-wrap: wrap;\n}\n.corporateContainer > h1 {\n  margin-top: 50px;\n  width: 100%;\n  padding: 0 80px;\n}\n.corporateContainer > div > div {\n  background-color: #eaeaea;\n  padding: 10px;\n  margin: 10px;\n}\n.container1{\n  background-color: white !important;\n  color: #ba1e24 !important;\n\n}\n\n\n.corporateContainer > div > div > p {\n  padding: 10px 0px;\n  margin: 10px 0px;\n}\n.corporateContainer > div > div > div {\n  display: flex;\n  align-items: center;\n  color: #000;\n  font-size: clamp(16px, 4vw, 22px) !important;\n  font-weight: 700;\n}\n.corporateContainer > div > div > div > span {\n  color: #000;\n  font-family: lightThicker !important;\n  font-size: clamp(16px, 4vw, 22px) !important;\n  font-weight: 400;\n}\n.slider > div > button {\n  background-color: #000 !important;\n}\n.slider > div > button.slick-arrow.slick-prev {\n  background-color: #000 !important;\n  position: absolute !important;\n  left: 0px !important;\n  color: black !important;\n  border: 1px solid black !important;\n}\n.slider > div > button.slick-arrow.slick-next {\n  position: absolute !important;\n  right: 0px !important;\n  border: 1px solid black !important;\n}\n\n.slider > div,\n.slider > div > div {\n  width: 100% !important;\n}\n.slider > div > div > div > div > div > div > div {\n  width: 100%;\n  height: 60vh;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.slider > div > div > div > div > div > div > div > div {\n  position: relative;\n  top: 550px;\n}\n/* .cardSlider {\n  height: 200px;\n  width: 100%;\n} */\n/* .cardSlider > div > button {\n  background-color: black !important;\n}\n.cardSlider > div > div > div > div {\n  width: 400px !important;\n  background: #fff;\n  margin: 5px;\n  box-shadow: 0px 0px 62px -6px rgba(0, 0, 0, 0.15);\n}\n.cardSlider > div > div > div > div > div > div > div > p {\n  color: #000;\n  font-family: lightThicker !important;\n  font-size: 14px;\n  font-weight: 400;\n}\n.cardSlider > div > div > div > div > div > div > div > div > div > img {\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.cardSlider > div > div > div > div > div > div > div > div > div > h3 {\n  color: #000;\n  font-size: 14px;\n  font-weight: 600;\n}\n.cardSlider > div > div > div > div > div > div > div > div > div > p {\n  color: #000;\n  font-size: 12px;\n  font-family: lightThicker !important;\n} */\n.cardSlider,\n.cardSlider > div,\n.cardSlider > div > div {\n  width: 100% !important;\n}\n.description > p {\n  color: #000 !important;\n  font-family: lightThicker !important;\n  font-size: 14px !important;\n  font-weight: 100 !important;\n}\n.cardDiv {\n  display: flex !important; \n}\n.cardDiv > img {\n  height: 40px !important;\n  width: 40px !important;\n  border-radius: 50% !important;\n  object-fit: cover;\n  margin-right: 10px !important;\n}\n.cardDiv > div > h2 {\n  color: #000;\n  font-size: 14px !important;\n  margin: 0px !important;\n}\n.cardDiv > div > p {\n  color: #000;\n  font-weight: 100 !important;\n  font-family: lightThicker !important;\n  font-size: 12px !important;\n  margin: 0px !important;\n}\n.cardWidth {\n  width: 100% !important;\n  background: #fff !important;\n  border: none !important;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;\n}\n.corporate_form_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.corporate_form_div {\n  width: 100%;\n  padding: 0 80px;\n}\n\n.corporate_form {\n  width: 100%;\n  display: flex;\n  margin-top: 30px;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 20 !important;\n}\n\n.corporate_field_box {\n  width: calc(33% - 20px);\n  display: flex;\n  flex-direction: column;\n  margin: 0 10px 25px 10px;\n}\n\n.corporate_field_box > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n}\n\n.corporate_field {\n  height: 50px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n}\n\n.corporate_text_area {\n  width: 66%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 25px 0;\n}\n\n.corporate_text_area > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n}\n\n.corporate_text_area_field {\n  height: 152px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n  resize: none;\n}\n\n.corporate_invalid_feedback {\n  color: #e42323;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0.25px;\n  margin-top: 4px;\n}\n\n.corporate_join_btn_div {\n  display: flex;\n  width: 180px;\n  height: 54px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;\n  color: #fff;\n  font-family: lightThicker;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  border: none;\n  margin-bottom: 50px;\n}\n\n\n@media screen and (max-width: 1200px) {\n\n.corporateContainer > div {\n  width: 100%;\n  margin: auto 0 50px 0;\n  padding: 0 80px;\n  flex-wrap: wrap;\n}\n\n.corporateContainer > h1 {\n  width: 100%;\n  margin: auto;\n  padding: 0 80px;\n}\n\n\n  .corporate_form_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .corporate_form {\n    /* justify-content: space-between; */\n    gap: 20 !important;\n  }\n\n  .corporate_field_box {\n    width: calc(33% - 20px);\n    margin: 0 10px 20px 10px;\n  }\n\n  .corporate_field_box > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .corporate_field {\n    height: 50px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .corporate_text_area {\n    width: 66%;\n    margin: 0 0 20px 0;\n  }\n\n  .corporate_text_area > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .corporate_text_area_field {\n    height: 130px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .corporate_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .corporate_join_btn_div {\n    width: 150px;\n    height: 45px;\n    gap: 10px;\n    font-size: 20px;\n    margin-bottom: 60px;\n  }\n\n\n\n}\n\n\n@media screen and (max-width: 1200px) {\n  .corporateContainer > div {\n    /* width: 90%; */\n  }\n\n  .carousel-item-content > div {\n    margin-top: -100px !important;\n    padding-left: 60px;\n  }\n\n  .carousel-item-content > div > p:first-child {\n    font-size: 28px;\n  }\n  \n  .carousel-item-content > div > p:last-child {\n    font-size: 18px;\n    margin: 2px 0 0 0 !important;\n  }\n\n  .corporateContainer > div {\n    width: 100%;\n    margin: auto 0 50px 0;\n    padding: 0 80px;\n    flex-wrap: wrap;\n  }\n  \n  .corporateContainer > h1 {\n    width: 100%;\n    margin: auto;\n    padding: 0 80px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n\n.corporateContainer > div {\n  padding: 0 60px;\n}\n\n.corporateContainer > h1 {\n  padding: 0 60px;\n}\n.corporate_form_div {\n  width: 100%;\n  padding: 0 30px;\n}\n\n.corporate_form {\n  /* justify-content: space-between; */\n  gap: 20 !important;\n}\n\n.corporate_field_box {\n  width: calc(50% - 6px);\n  margin: 0 3px 16px 3px;\n}\n\n.corporate_field_box > label {\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.corporate_field {\n  height: 45px !important;\n  padding: 0 14px;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.corporate_text_area {\n  width: 100%;\n  margin: 0 0 16px 0;\n}\n\n.corporate_text_area > label {\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.corporate_text_area_field {\n  height: 120px !important;\n  padding: 10px 14px;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.corporate_invalid_feedback {\n  font-size: 14px;\n  line-height: 18px;\n  margin-top: 4px;\n}\n\n.corporate_join_btn_div {\n  width: 140px;\n  height: 42px;\n  gap: 10px;\n  font-size: 18px;\n  margin-bottom: 60px;\n}\n}\n\n\n\n@media screen and (max-width: 800px) {\n\n  .carousel-item-content > div {\n    margin-top: -80px !important;\n    padding-left: 20px;\n  }\n.secondHeadingCorporate \n{\n  margin: -50px 0 30px 0;\n}\n.unorderdListCorporate li{\n  font-size: 16px;\n}\n  .carousel-item-content > div > p:first-child {\n    font-size: 24px;\n  }\n  \n  .carousel-item-content > div > p:last-child {\n    font-size: 16px;\n    line-height: 20px;\n    margin: 0 !important;\n  }\n\n  .corporateContainer > div {\n    padding: 0 30px;\n  }\n  \n  .corporateContainer > h1 {\n    padding: 0 30px;\n  }\n}\n\n\n@media screen and (max-width: 600px) {\n.bannerDesc{\n  margin-top: 12px;\n}\n  .corporateContainer > div {\n    width: 100% !important;\n    padding: 0 16px;\n  } \n\n  .corporateContainer > div > div {\n    padding: 10px;\n    margin: 10px 0;\n    width: 100%;\n  }\n\n  .corporateContainer > h1 {\n    margin-top: 20px;\n    margin-left: 0 !important;\n    padding: 0 20px;\n    font-size: 26px !important;\n    line-height: 26px;\n  }\n  .corporateContainer > p {\n    width: 90%; \n    margin-bottom: 20px;\n  }\n  .slider > div,\n  .slider > div > div {\n    width: 100% !important;\n  }\n  .bottomCorporate > button {\n    margin-top: 20px;\n    padding: 4px 15px;\n  }\n  .bannerHeadingSubHeading p {\n    display: none;\n  }\n\n  .corporate_form_div {\n    width: 100%;\n    padding: 0 20px;\n  }\n \n  .corporate_form {\n    /* justify-content: space-between; */\n    gap: 10 !important;\n  }\n\n  .corporate_field_box {\n    width: 100%;\n    margin: 0 0 16px 0;\n  }\n\n  .corporate_field_box > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .corporate_field {\n    height: 45px !important;\n    padding: 0 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .corporate_text_area {\n    width: 100%;\n    margin: 0 0 12px 0;\n  }\n\n  .corporate_text_area > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .corporate_text_area_field {\n    height: 120px !important;\n    padding: 10px 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .corporate_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .corporate_join_btn_div {\n    width: 140px;\n    height: 42px;\n    gap: 10px;\n    font-size: 18px;\n    margin-bottom: 60px;\n  }\n\n  .carousel-item-content > div {\n    margin-top: -40px !important;\n    padding-left: 10px;\n  }\n\n  .carousel-item-content > div > p:first-child {\n    font-size: 18px;\n  }\n  \n  .carousel-item-content > div > p:last-child {\n    font-size: 12px;\n    line-height: 16px;\n    margin: 0 !important;\n    display: none;\n  }\n\n\n  .corporateContainer > div >div > img {\n    width: 100% !important;\n  }\n}\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .corporateContainer > h1 {\n    margin-top: -20px !important;\n    padding: 0 16px;\n    font-size: 20px !important;\n    line-height: 26px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
